import { useConnectedAccounts } from "./use-connected-accounts";
import { useMemo } from "react";
import { CONNECTION_TYPES } from "@/config";
import { useAuth } from "@/contexts/auth-context";

type Provider = "instagram" | "youtube" | "tiktok";

export const useShowConnectAccount = () => {
  const { user } = useAuth();
  const { accounts, isLoading } = useConnectedAccounts();

  const { providerCounts, shouldShow } = useMemo(() => {
    const counts: Record<Provider, number> = {
      instagram: 0,
      youtube: 0,
      tiktok: 0,
    };
    let activeCount = 0;

    if (accounts && accounts.length > 0) {
      for (const account of accounts) {
        if (account.status === "active") {
          activeCount++;
          const connectionType = account.connection_type;
          if (
            connectionType === CONNECTION_TYPES.INSTAGRAM_DIRECT ||
            connectionType === CONNECTION_TYPES.INSTAGRAM_VIA_FACEBOOK
          ) {
            counts.instagram++;
          } else if (
            connectionType === CONNECTION_TYPES.YOUTUBE
          ) {
            counts.youtube++;
          } else if (
            connectionType === CONNECTION_TYPES.TIKTOK ||
            connectionType === CONNECTION_TYPES.TIKTOK_BUSINESS
          ) {
            counts.tiktok++;
          }
        }
      }
    }

    const shouldShow = !!user && !isLoading && activeCount === 0;
    return { providerCounts: counts, shouldShow };
  }, [accounts, isLoading, user]);

  return { shouldShow, providerCounts, isLoading };
};
